module.exports = __webpack_public_path__ + "472f67c477d6a10694245507e6731688.png";